"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _json2mq = _interopRequireDefault(require("json2mq"));
var _useAssociativeArray = _interopRequireDefault(require("./useAssociativeArray"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();
var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};
const useMedia = mediaQueries => {
  const matchMedia = (0, _react.useCallback)(key => {
    const query = mediaQueries[key];
    return window.matchMedia(typeof query === 'string' ? query : (0, _json2mq.default)(query));
  }, [mediaQueries]);
  const [items, addItem] = (0, _useAssociativeArray.default)({
    mediaQueries,
    matchMedia
  });
  (0, _react.useEffect)(() => {
    const disposeAll = Object.keys(mediaQueries).map(key => {
      const list = matchMedia(key);
      const listener = () => {
        if (list.matches) {
          addItem('device', key);
        }
        addItem(key, list.matches);
      };
      const dispose = () => list.removeListener(listener);
      list.addListener(listener);
      listener();
      return dispose;
    });
    return () => {
      disposeAll.forEach(dispose => dispose());
    };
  }, [addItem, matchMedia, mediaQueries]);
  return items;
};
__signature__(useMedia, "useCallback{matchMedia}\nuseAssociativeArray{[items, addItem]}\nuseEffect{}", () => [_useAssociativeArray.default]);
const _default = useMedia;
var _default2 = exports.default = _default;
;
(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;
  if (!reactHotLoader) {
    return;
  }
  reactHotLoader.register(useMedia, "useMedia", "/Users/jake.clayton/frontend/ls-common-client/src/hooks/useMedia.js");
  reactHotLoader.register(_default, "default", "/Users/jake.clayton/frontend/ls-common-client/src/hooks/useMedia.js");
})();
;
(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();